<template>
  <div>
    <div class="type-body">
      <div class="type-box" @click="typeClick(1)">
        <div class="title" :class="type == 1 ? 'title-click' : ''">平台明细</div>
        <div v-if="type == 1" class="l"></div>
      </div>
      <div v-if="$hasFeature('out_order')" class="type-box" @click="typeClick(2)">
        <div class="title" :class="type == 2 ? 'title-click' : ''">外部明细</div>
        <div v-if="type == 2" class="l"></div>
      </div>
      <div v-if="$hasFeature('dispatch_order')" class="type-box" @click="typeClick(3)">
        <div class="title" :class="type == 3 ? 'title-click' : ''">派单明细</div>
        <div v-if="type == 3" class="l"></div>
      </div>
    </div>
    <div v-if="type == 1 && $hasFeature('clerk_quity')" class="information-body">
      <div class="information-box">
        <div class="title">扣税金额</div>
        <div class="information">{{deductTaxWages > 0 ? formatPrice(deductTaxWages) : 0}}</div>
      </div>
    </div>
    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="loadData"
    >
      <div class="wages-body">
        <div class="wages-box" v-for="(item,index) of list" :key="index">
          <template v-if="version===1">
            <div class="data-box">
              <div class="title">订单号</div>
              <div class="data1">{{item.no}}</div>
            </div>
            <div class="data-box">
              <div class="title">订单金额</div>
              <div class="data2">￥{{formatPrice(item.totalAmount)}}</div>
            </div>
            <div class="data-box">
              <div class="title">工资</div>
              <div class="data2">￥{{formatPrice(item.clerkWagesAmount)}}</div>
            </div>
            <div class="data-box">
              <div class="title">完成时间</div>
              <div class="data1">{{formatDate(item.endTime)}}</div>
            </div>
            <router-link :to="type == 1 ? '/clerk/order/detail/' + item.id : type == 2 ? '/clerk/order/out-order-list?orderNo=' + item.no : '/clerk/dispatchOrder/detail/' + item.id">
              <div class="more">
                <span>订单详情</span>
                <img src="/static/images/default/r.png">
              </div>
            </router-link>
          </template>
          <template v-if="version===2">
            <router-link :to="type == 1 ? '/clerk/order/detail/' + item.orderId : type == 2 ? '/clerk/order/out-order-list?orderNo=' + JSON.parse(item.detail).orderNo : '/clerk/dispatchOrder/detail/' + item.orderId">
            <div class="data-box">
              <div class="title" style="color: #101010">{{$store.state.AccountBalanceLogActionEnum.getLabel(item.action)}}</div>
              <div class="data1" style="color: #101010">{{item.changeAmount>=0?'+':''}}{{formatPrice(item.changeAmount)}}</div>
            </div>
            <div class="data-box">
              <div class="title">{{formatDate(item.createTime,'YYYY-MM-DD HH:mm:ss')}}</div>
              <div class="data1">账号余额：{{formatPrice(item.afterChangeAmount)}}</div>
            </div>
            </router-link>
          </template>

        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Cell, CellGroup, Tab, Tabs, List, Toast, Dialog } from 'vant';
  import Decimal from 'decimal.js';
  import moment from 'moment';
  import { getWagesDetail } from '@/api/clerk/wages'

  Vue.use(Cell)
      .use(CellGroup)
      .use(Tab)
      .use(Tabs)
      .use(List)
      .use(Toast)
      .use(Dialog)

  export default {
    name: 'wages-detail',
    data () {
      return {
        list: [],
        deductTaxWages: 0,
        type: 1,
        loading: false,
        listFinished: false,
        pageNo: 1,
        pageSize: 10,
        version: JSON.parse(decodeURIComponent(this.$route.query.row)).version,
        startTime: JSON.parse(decodeURIComponent(this.$route.query.row)).startTime,
        endTime: JSON.parse(decodeURIComponent(this.$route.query.row)).endTime
      }
    },
    methods: {
      typeClick(type){
        this.type = type
        this.loadData(true)
      },
      formatDate(date, format) {
        if (!date) {
          return '';
        }
        if (!format) {
          format = 'YYYY-MM-DD'
        }
        return moment(date).format(format);
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toFixed(2).toString()
        }
        return ''
      },
      loadData(resetFirstPage) {
        // 重置
        if (resetFirstPage) {
          this.pageNo = 1
        }
        // 清空数据
        if (this.pageNo == 1) {
          this.list = [];
        }
        this.loading = true
        getWagesDetail({
          type: this.type,
          version: this.version,
          startTime: this.startTime,
          endTime: this.endTime,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }).then(res => {
          this.loading = false
          const data = res.data;
          if (data.code == 0) {
            this.list = this.list.concat(data.list)
            if (data.hasNextPage) {
              this.listFinished = false
            } else {
              this.listFinished = true
            }
            this.deductTaxWages = data.deductTaxWages
          } else {
            this.listFinished = true
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
          this.pageNo ++
        })
      }
    },
    mounted() {},
    updated() {}
  }
</script>

<style lang="less" scoped>
.type-body{
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: calc(100% - 28px * 2);
  padding: 16px 28px 9px 28px;
  .type-box{
    display: flex;
    flex-flow: column;
    align-items: center;
    .title{
      color: #808080;
      font-size: 15px;
      font-weight: 500;
    }
    .title-click{
      color: #333;
      font-weight: bold;
    }
    .l{
      margin-top: 5px;
      height: 3px;
      width: 40%;
      border-radius: 3px;
      background: #3990FC;
    }
  }
}
.information-body{
  width: calc(100% - 13px * 2);
  padding: 0 13px;
  .information-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
    background: #fff;
    border-radius: 7px;
    padding: 17px 16px 13px 16px;
    margin-bottom: 5px;
    .title{
      font-size: 13px;
      color: #808080;
      font-weight: 500;
    }
    .information{
      font-size: 13px;
      color: #333;
      font-weight: 500;
    }
  }
}
.wages-body{
  width: calc(100% - 13px * 2);
  padding: 0 13px;
  .wages-box{
    background: #fff;
    border-radius: 7px;
    padding: 17px 16px 13px 16px;
    margin-bottom: 5px;
    .data-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 13px;
      .title{
        color: #808080;
        font-size: 13px;
        font-weight: 500;
      }
      .data1{
        color: #808080;
        font-size: 13px;
        font-weight: 500;
      }
      .data2{
        color: #333;
        font-size: 13px;
        font-weight: 500;
      }
    }
    .more{
      border-top: 1px #EBEBEB solid;
      padding-top: 13px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span{
        color: #B3B3B3;
        font-size: 13px;
        font-weight: 500;
      }
      img{
        height: 12px;
        display: block;
      }
    }
  }
}
</style>
